import { Axios } from "../../service/serviceBasic";
import {
  SET_MESSAGE_CONFIRMACAOEMAIL_ALTERACAO,
  SET_LOADING_VALUE_ALTERACAO_EMAIL,
  // SET_ERROR_VALUE,
} from "./types";
import { toast } from "react-toastify";

const setMessageConfirmacaoEmailAlteracaoAction = (obj) => ({
  type: SET_MESSAGE_CONFIRMACAOEMAIL_ALTERACAO,
  payload: obj,
});

const setLoadingValue = (flag) => ({
  type: SET_LOADING_VALUE_ALTERACAO_EMAIL,
  payload: flag,
});

export const checkConfirmationHashAction = (id) => (dispatch) => {
  dispatch(setLoadingValue(true));
  let screenInfo;

  return Axios.post("v1/basico/pessoa/confirmarTrocaEmail", {
    IdValidacaoEmail: id,
  })
    .then(() => {
      screenInfo = {
        icon: "fa-check-circle-o",
        title: "E-mail alterado com sucesso!",
        discription:
          "Esse endereço de email será usado em todas as comunicações da B&T Câmbio com você.",
      };
    })
    .catch((error) => {
      screenInfo = {
        icon: "fa-times-circle-o",
        title: "Oops!",
        discription:
          "Não encontramos a solicitação de alteração ou o email já foi confirmado.",
      };
      toast.warn("Tente novamente, ou dirija-se a uma loja da B&T Câmbio", {
        position: toast.POSITION.BOTTOM_RIGHT,
        className: "ui-alert-toast",
      });
    })
    .finally(() => {
      dispatch(setMessageConfirmacaoEmailAlteracaoAction(screenInfo));
      dispatch(setLoadingValue(false));
    });
};
